<template>
  <div>
    <UploadImages />
    <SelectColor />
    <Message />
    <Discount
      v-if="showDiscount"
      v-test="'discountSection'"
    />
    <MainButton />
    <Footer />
  </div>
</template>

<script
  setup
  lang="ts"
>
import { useUserStore } from '@/stores/user';
import { useMarketingBuilderStore } from '../../store/builder';
import Discount from './Discount.vue';
import Footer from './Footer.vue';
import MainButton from './MainButton.vue';
import Message from './Message.vue';
import SelectColor from './SelectColor.vue';
import UploadImages from './UploadImages.vue';

const { hasFeatureFlag } = useUserStore();

const hideDiscount = computed(() => {
  const { hideDiscount } = useMarketingBuilderStore();
  return hideDiscount;
});

const showDiscount = computed(
  () => !hideDiscount.value && hasFeatureFlag('module-marketing'),
);
</script>
